import React from 'react';
import { Container } from 'reactstrap';
import CrudList from './list';

const RequerimentoFase = () => (
  <div className="containerInside__wrap">
    <Container>
      <CrudList />
    </Container>
  </div>
);

export default RequerimentoFase;